import {IFilterCategoryDefinition} from "../interfaces/filter-category-definition.interface";
import {IGameFilterDefinition} from "../interfaces/game-filter-definition.interface";
import {CustomFilter} from "../filters-definitions/custom.filter";
import {Check} from "@sparkware/app-utils";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {GameInfo} from "../../games/game-info";
import {AND} from "../evaluators/and-game-filters-evaluator";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";

export class GameFeatureFiltersCategory implements IFilterCategoryDefinition {
    constructor(private readonly services: IServiceFactoryExtended) {
    }

    get title(): string{
        return this.services.translation.translate('Game Features');
    }

    applyFilters(gameInfo: GameInfo, filters: IGameFilterDefinition[]): ApplyGameFilterResult {
        const result = AND(...filters).applyFilter(gameInfo);
        return result;
    }

    availableFilters: IGameFilterDefinition[] = [
        new CustomFilter('one-to-twenty-five',  (gameInfo) => Check.isNumber(gameInfo.numberOfLines) && gameInfo.numberOfLines >= 1 && gameInfo.numberOfLines <= 24),
        new CustomFilter('twenty-five-plus',  (gameInfo) => Check.isNumber(gameInfo.numberOfLines) && gameInfo.numberOfLines >= 25),
        new CustomFilter('jackpot',  (game) => game.hasJackpot),
        new CustomFilter('new',  (game) => game.isNewGame),
        new CustomFilter('lowStakes',  (game) => game.hasLowStakes),
        new CustomFilter('classicSlots',  (game) => game.isClassicSlot),
        new CustomFilter('bonus',  (game) => game.hasBonusGames),
        new CustomFilter('freeSpins',  (game) => game.hasFreeSpins),
        new CustomFilter('highVolatility',  (game) => game.hasHighVolatility),
        new CustomFilter('lowVolatility',  (game) => game.hasLowVolatility)
    ];
}